module.exports = __webpack_public_path__ + "img/banner_01.48efb40f.jpg";